module.exports = __webpack_public_path__ + "d8fcc8859610c8bb70b154d3a65d036e.png";